(function () {
    'use strict';

	angular
	    .module('app')
	    .controller('Error404Controller', Error404Controller);

	Error404Controller.$inject = ['$rootScope', '$scope', '$location'];
	function Error404Controller($rootScope, $scope, $location) {     

	    $scope.original = $location.path();
		
		initController();

	    function initController() {
	    	$location.path('/');
	    }    
	}
})();